<template>
  <el-col :span="20">
    <el-card>
      <div class="tag-group">
        <div class="tag-group__title">招募类型</div>
        <el-tag
          v-for="item in waitList"
          :key="item.value"
          class="filter-tag"
          :type="activeWaitType ===item.value?'success':'info'"
          @click="handleActiveWaitType(item.value)"
        >
          {{ item.label }}
        </el-tag>
      </div>
      <div class="tag-group">
        <div class="tag-group__title">筛选项</div>
        <el-tag
          class="filter-tag"
          :type="activeFilter.length===0?'success':'info'"
          @click="activeFilter = []"
        >
          全部
        </el-tag>
        <el-tag
          v-for="item in filterList"
          :key="item.label"
          class="filter-tag"
          :type="handleTagType(item)"
          @click="handleSelectFilter(item)"
        >
          {{ item.label }}
        </el-tag>
        <el-tag class="filter-tag" @click="openFilterManagement">
          + 管理筛选项
        </el-tag>
      </div>
    </el-card>
    <div style="margin: 10px 20%;text-align: center">
      <el-link v-if="loading" :underline="false" icon="el-icon-loading">刷新中</el-link>
      <el-link v-else :underline="false" icon="el-icon-refresh" @click="refresh">点此刷新</el-link>
    </div>
    <el-row class="result-group" :gutter="20">
      <el-col v-for="item in resultList" :key="item.key" :span="8">
        <el-skeleton :loading="loading" animated>
          <template slot="template">
            <el-card class="result-card">
              <div class="box-top">
                <div style="display: flex">
                  <div>
                    <el-skeleton-item
                      variant="image"
                      style="width: 40px; height: 40px; border-radius: 50%"
                    />
                  </div>
                  <div style="margin-left: 10px;font-size: 14px;">
                    <div>
                      <el-skeleton-item variant="text" style="width: 100px; height: 19px" />
                    </div>
                    <div>
                      <el-skeleton-item variant="text" style="width: 40px; height: 19px" />
                    </div>
                  </div>
                </div>
                <div style="margin-left: 10px;font-size: 14px;">
                  <el-skeleton-item variant="text" style="width: 66px; height: 25px" />
                </div>
              </div>
              <div class="box-middle">
                <el-skeleton-item variant="text" style="height: 70px" :rows="3" />
              </div>
              <div class="box-bottom">
                <div class="player-name">
                  <el-skeleton-item variant="text" style="margin-right: 16px;" />

                </div>
              </div>
            </el-card>
          </template>
          <template>
            <el-card class="result-card">
              <div class="box-top">
                <div style="display: flex">
                  <div> <el-avatar :src="item.user.avatar" /></div>
                  <div style="margin-left: 10px;font-size: 14px;">
                    <div>{{ item.user.username }}</div>
                    <div>{{ item['create_str'] }}</div>
                  </div>
                </div>
                <div v-if="item['tags']&&item['tags'].length>1" style="margin-left: 10px;font-size: 14px;">
                  <div :style="{'background':item['tags'][0]['color']}" class="content-tag">
                    {{ item['tags'][0]['desc'] }}
                  </div>
                </div>
              </div>
              <div class="box-middle">
                {{ item['content_text']?item['content_text']:'' }}
              </div>
              <div class="box-bottom">
                <div class="player-name">
                  {{ item['game_id']?item['game_id']:'未填写' }}
                </div>
                <i
                  v-clipboard:copy="handleCopy(item)"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  class="el-icon-document-copy"
                />
              </div>
            </el-card>
          </template>
        </el-skeleton>
      </el-col>
    </el-row>
    <filter-management
      ref="filterManagement"
      :visible.sync="showFilterManager"
      @update-change="refreshFilter"
    />
  </el-col>
</template>

<script>
import FilterManagement from '@/view/d2/conponents/filter-management'

// import { getList } from '@/api/hey-box'
import { getKeyWords, initKeyWords } from '@/utils/keywords'
import { dateDiffFormatter } from '@/utils/date'

export default {
  name: 'FindGroup',
  components: { FilterManagement },
  filters: {
    dateFormatter(value) {
      return dateDiffFormatter(value)
    }
  },
  data() {
    return {
      showFilterManager: false,
      filterList: [],
      waitList: [
        { label: '全部', value: 'all' },
        { label: '限时10分钟', value: '10min' },
        { label: '限时30分钟', value: '30min' },
        { label: '长期招募', value: 'long' }
      ],
      activeFilter: [],
      activeWaitType: 'all',
      loading: false,
      dataList: [
      ],
      resultList: []
    }
  },
  watch: {
    // 监听activeFilter的变化，当activeFilter发生变化时，过滤dataList
    activeFilter() {
      this.getFilterList()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const keyWords = getKeyWords()
      if (!keyWords) {
        this.filterList = initKeyWords()
      } else {
        this.filterList = keyWords
      }
      this.getList()
    },
    handleTagType(label) {
      return this.activeFilter.indexOf(label) > -1 ? 'success' : 'info'
    },
    openFilterManagement() {
      this.showFilterManager = true
      this.$nextTick(() => {
        this.$refs.filterManagement.init()
      })
    },
    handleSelectFilter(item) {
      const index = this.activeFilter.indexOf(item)
      if (index > -1) {
        this.activeFilter.splice(index, 1)
      } else {
        this.activeFilter.push(item)
      }
    },
    refresh() {
      this.getList()
    },
    getList() {
      // this.loading = true
      // getList({ waitingType: this.activeWaitType }).then(res => {
      //   this.dataList = res
      //   this.getFilterList()
      // }).finally(() => {
      //   this.loading = false
      // })
    },
    getFilterList() {
      if (this.activeFilter.length === 0) {
        this.resultList = this.dataList
      } else {
        this.resultList = this.dataList.filter(item => {
          return this.activeFilter.some(filter => {
            return filter.rules.split(',').some(rule => {
              return item['content_text'].includes(rule)
            })
          })
        })
      }
    },
    refreshFilter() {
      this.init()
      this.activeFilter = []
    },
    handleCopy(item) {
      return item['game_id']
    },
    onCopy() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    },
    handleActiveWaitType(type) {
      this.activeWaitType = type
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
.tag-group{
  margin: 10px 0;
}
.tag-group__title {
  display: inline-block;
  min-width: 80px;
  text-align: right;
  margin-right: 10px;
}
.filter-tag{
  user-select: none;
  margin: 5px;
  cursor: pointer;
}
.filter-tag >>> .el-tag {
  margin: 0 5px;
}
.el-aside {
  color: #333;
}
.result-card {
  margin: 10px 0;
}
.result-card  ::v-deep  .el-card__body{
  padding: 5px;
}
.box-top{
  display: flex;
  border-bottom: 1px solid #ebebeb;
  padding: 5px;
  height: 40px;
  justify-content: space-between;
}
.box-middle{
  height: 50px;
  padding: 20px 10px;
}
.box-bottom{
  display: flex;
  padding: 0 10px;
  align-items: center;
  height: 30px;
}
.player-name{
  margin-right: 10px;
  font-size: 13px;
}
.content-tag{
  padding: 3px 5px;
  color: #FFFFFF;
  border-radius: 4px;
}
</style>
